import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['container', 'item', 'question', 'answer', 'separator', 'toggleFaqButton']

  connect() {
    this.showAll = true;
    this.toggleVisibility();
  }

  toggleOpen(event) {
    const item = this.itemTargets.find(target => target.contains(event.target))
    const itemId = item.id.split('-')[1]
    const currentQuestion = this.questionTargets.find(target => target.id === `question-${itemId}`)
    const currentAnswer = this.answerTargets.find(target => target.id === `answer-${itemId}`)

    if (currentQuestion.classList.contains('open')) {
      // If the current tab is open, close it
      currentAnswer.style.maxHeight = null;
      currentAnswer.style.height = '0px';
      currentQuestion.classList.remove('open');
    } else {
      // If the current tab is closed, open it
      this.answerTargets.forEach(answer => {
        answer.style.maxHeight = null;
        answer.style.height = '0px';
      });
      this.questionTargets.forEach(question => {
        question.classList.remove('open');
      });

      currentAnswer.style.height = currentAnswer.scrollHeight + "px";
      currentAnswer.style.maxHeight = currentAnswer.scrollHeight + "px";
      currentQuestion.classList.add('open');
    }
  }

  toggleVisibility() {
    this.showAll = !this.showAll;
    this.toggleItems(this.showAll ? 'block' : 'none');
    this.toggleFaqButtonTarget.innerText = this.showAll ? 'Show less FAQs' : 'See all FAQs';
  }
  
  toggleItems(displayStyle) {
    [...this.separatorTargets.slice(4, -1), ...this.itemTargets.slice(4, -1)].forEach(n => {
      n.style.display = displayStyle;
    });
  }
}
